import { useWindowSize } from '@vueuse/core';
import { computed } from 'vue';

const { width } = useWindowSize();

export function styleToPixels(value: string | undefined): number {
  if (value?.length && value.length > 0) {
    if (value.endsWith('px')) {
      return parseInt(value.substring(0, value.length - 2), 10);
    }
    if (value.endsWith('rem')) {
      return parseFloat(value.substring(0, value.length - 3)) * 16;
    }
  }
  return -1;
}

const SCREENS = { lg: '1024px', xl: '1280px' };
const SPACING = { 96: '24rem' };

export const tailwindTheme = { screens: SCREENS, spacing: SPACING };

export const isScreenXl = computed(() => width.value > styleToPixels(tailwindTheme.screens.xl));
